<template>
  <div>
    <transition name="slide" :duration="searchAwareDuration">
      <nav v-if="active">
        <div class="content" v-bind:class="{ '-no-translate': !translate }">
          <div class="default" v-bind:class="{ 'is-active': panel.active }">
            <div class="panel-a">
              <h3 class="px-4 mb-0 pb-2 pt-4" style="color: #0D0A15">
                {{ items[1].name }}
              </h3>
              <ul>
                <li v-for="(item, index) in items[1].children">
                  <a :href="item.href" @click="onMobileNavClick(item, index)">{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="panel-b">
              <group
                v-if="panel.active"
                v-bind:active.sync="panel.active"
                v-bind:site="panel.group"
              ></group>
            </div>
          </div>

          <div class="wrapper">
            <div
              class="customer-service pb-4"
              v-bind:class="{ 'pb-4': panel.active }"
            >
              <p class="contact-us">
                <span>{{ $getTranslation("Connect with Customer Service", $route.params.region) }}:</span>
                <a
                  v-if="items && items[2] && items[2].href"
                  :href="items[2].href"
                  @click="onMobileUtilityClick(items[2])"
                >
                  <span>{{ $getTranslation("Contact", $route.params.region) }}</span>
                </a>
              </p>
            </div>

            <div class="resmed-corporate">
              <ul>
                <li>
                  <a
                    :href="items[0].href"
                    :target="items[0].target"
                    class="prev"
                    v-if="items[0] !== undefined"
                    @click="onMobileUtilityClick(items[0])"
                    >{{ items[0].name }}</a
                  >
                </li>
              </ul>
            </div>

            <div class="utility">
              <ul>
                <li>
                  <a
                    :href="items[0].href"
                    :target="items[0].target"
                    class="prev"
                    v-if="items[0] !== undefined"
                    @click="onMobileUtilityClick(items[0])"
                    >{{ items[0].name }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="overlay"></div>
      </nav>
    </transition>

    <transition
      name="custom-slide-in-out-transition"
      enter-active-class="animated slide-in-down"
      leave-active-class="animated slide-out-up"
    >
      <nav v-if="searchActive">
        <div class="content">
          <div class="default">
            <div class="panel-z search-form-wrapper">
              <h5 class="text-white search-text mb-2">
                {{ $getTranslation("What can we help you find?", $route.params.region)}}
              </h5>
              <search-form></search-form>
            </div>
          </div>
        </div>
      </nav>
    </transition>
  </div>
</template>

<script>
import scroll from "../../mixins/scroll";
import group from "./group";
import { track_menu_click } from "../../analytics/events";
import wpApi from "../../services/wpApi";

export default {
  name: "header-items-sm-md",
  components: {
    group,
  },
  mixins: [scroll],
  data() {
    return {
      searchActive: false,
      active: false,
      duration: 0,
      translate: true,
      items: [],
      panel: {
        active: false,
        group: undefined,
      },
      utility: [],
    };
  },
  watch: {
    active(v) {
      if (v) {
        this.searchActive = false;
      }
    },
    searchActive(v) {
      this.$emit("on-search-active-changed", v);
    },
  },
  computed: {
    searchAwareDuration() {
      return this.searchActive ? 0 : this.duration;
    },
  },
  methods: {
    // ── Analytics helpers ──────────────────────────────────────────
    onMobileNavClick(item, position) {
      if (!item.href) return;
      track_menu_click({
        clicked_area: "header",
        component_name: "header-items-sm-md",
        component_variant: "mobile",
        navigation_level_1: this.items[1] ? this.items[1].name : "",
        navigation_level_2: item.name,
        navigation_depth: 2,
        clicked_text: item.name,
        clicked_url: item.href,
        position,
      });
    },
    onMobileUtilityClick(item) {
      if (!item.href) return;
      track_menu_click({
        clicked_area: "header",
        component_name: "header-items-sm-md",
        component_variant: "mobile-utility",
        navigation_level_1: item.name,
        navigation_depth: 1,
        clicked_text: item.name,
        clicked_url: item.href,
      });
    },
    // ── Existing methods ───────────────────────────────────────────
    group(arg) {
      if (this.panel.active) {
        this.panel.active = false;

        setTimeout(() => {
          this.panel.active = true;
          this.panel.group = arg;
        }, 900);
      } else {
        this.panel.active = true;
        this.panel.group = arg;
      }
    },
  },
  created() {
    let arr = location.pathname.split("/").filter((e) => e),
      myair = {
        name: "myAir",
        href: "https://myair.resmed.com/",
        target: "_blank",
      },
      site = arr[1];

    if (!["sleep-apnea", "portable-oxygen", "ventilation"].includes(site)) {
      site && (site = "resmed-corporate");
    }

    if (site) {
      this.translate = false;
    }

    this.utility = [
      {
        name: "Product Support",
        href: "https://support-dev.resmed.com/",
        target: "_blank",
      },
      {
        name: "United States",
        href: "https://www.resmed.com/us/en/country-selector.html",
        target: "_blank",
      },
    ];

    if (site === "ventilation" || site === "portable-oxygen") {
      this.utility.shift();
    }

    bus.$on("hamburger:active", (val) => {
      if (this.$root.site === "default") {
        let exception = false;

        for (let val of Object.keys(this.$root.$refs)) {
          exception = ["is-search", "is-404-default"].some((el) => {
            return el === val;
          });
        }

        if (exception) {
          site = "";
          this.translate = true;
        }
      }

      if (!val) {
        this.panel.active = false;
        this.panel.group = undefined;
      }

      this.$nextTick(() => {
        this.active = val;

        setTimeout(() => {
          if (site) {
            this.panel.active = true;
            this.panel.group = site;
          }
        }, 200);
      });
    });

    bus.$on("hamburger:mobile-search", (v) => {
      this.searchActive = v;

      if (v) {
        this.scroll({
          to: "html",
          duration: 1,
        });
      }
    });

    this.duration = 100 * this.items.length + 1700;

    // Get top menu bar links
    wpApi.getTopNavigation(this.$route.params.region).then((response) => {
      this.items = response.data;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/variables";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/components/navigation";

.search-form-wrapper {
  background: #0c0c0c;
  height: 100%;
  max-height: 200px;
  padding: 2rem;
  .search-text {
    color: #f7f7f7;
    font-size: 20px;
  }
  @media (max-width: 767px) {
    height: 300px;
    max-height: 300px;
  }
}

@-webkit-keyframes slide-in-down {
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slide-in-down {
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.slide-in-down {
  animation-name: slide-in-down;
}

@-webkit-keyframes slide-out-up {
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
  }
}

@keyframes slide-out-up {
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
  }
}

.slide-out-up {
  animation-name: slide-out-up;
}

.animated {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-delay: 0s;
}

.slide-enter {
  .overlay {
    height: 0;
    opacity: 0.5;
  }

  li,
  .customer-service {
    opacity: 0;
    transform: translateX(60vw);
  }

  .-no-translate {
    li,
    .customer-service {
      transform: translateX(0);
    }
  }

  .utility-black {
    opacity: 0;
  }
  .utility {
    opacity: 0;
  }
}

.slide-enter-active {
  .overlay {
    transition: height 0.75s ease-out, opacity 0.5s ease;
  }

  li,
  .customer-service {
    transition: opacity 1700ms ease-out, transform 1s ease-out;
  }

  .customer-service {
    transition-delay: 0.5s;
  }

  .utility-black {
    opacity: 0;
  }
  .utility {
    transition: opacity 1.5s ease;
  }
}

.slide-leave-active {
  .overlay {
    transition: height 0.875s ease-out;
    transition-delay: 1s;
  }

  li,
  .customer-service {
    transition: opacity 1700ms ease-out, transform 1s ease-in;
  }

  .utility-black {
    opacity: 0;
  }
  .utility {
    transition: opacity 0.5s ease;
  }
}

.slide-leave-to {
  .overlay {
    height: 0;
  }

  li,
  .customer-service {
    opacity: 0;
    transform: translateX(100vw);
  }

  .utility-black {
    opacity: 0;
  }
  .utility {
    opacity: 0;
  }
}

.overlay {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: $cc-resmed-white;
}

.content {
  display: flex;
  flex-direction: column;

  position: relative;
  z-index: 1;

  @media (max-width: 991px) {
    min-height: 100vh;
  }
}

nav {
  position: absolute;
  top: 0;

  overflow: hidden;
  min-height: 100vh;
  width: 100vw;

  ul {
    list-style: none;
    padding: 1rem 2rem;

    li {
      transform: translateX(0);

      @for $i from 1 through 10 {
        &:nth-child(#{$i}) {
          transition-delay: #{$i/10 + 0.25}s;
        }
      }
    }
  }

  .default {
    padding-top: $nav-xs-height;
    width: 200vw;

    display: flex;
    flex-grow: 1;
    flex-wrap: nowrap;

    transition: all 0.75s ease-out;

    @media (min-width: 576px) {
      padding-top: $nav-sm-height;
    }

    > [class^="panel-"] {
      width: 100vw;
    }

    &.is-active {
      transform: translateX(-100vw);
    }
  }

  .default,
  .resmed-corporate {
    ul {
      li {
        @extend %default-list-style;
      }
    }
  }

  .resmed-corporate {
    background-color: #ecebea;
    ul {
      padding-bottom: 0.125rem;

      li {
        border: none;
        border-top: 1px solid $cc-resmed-bg-grey-1;
        background-image: url(#{$assets}/images/icon-left-arrow-black.svg);
        background-position: left center;
        a {
          padding-left: 2rem;
        }
      }
    }
  }

  .customer-service {
    @extend %body-small;
    padding: 3rem 2rem 0 2rem;

    span {
      display: block;
      margin-bottom: 0.5rem;

      &:last-child {
        margin: 0;
      }

      &.phone {
        @extend %heading-m;
        color: $cc-resmed-action-red;
      }
    }
  }

  .utility-black {
    display: none;
    background-color: #0D0A15 !important;

    ul {
      padding: 2rem;

      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;

      li {
        flex-grow: 1;
        text-align: center;

        a {
          @extend %body-x-small-bold;
          color: $cc-resmed-white;
          display: inline-block;

          @media (min-width: 576px) {
            font-size: $font-size-sm;
          }
        }

        &:not(:first-child) {
          border-left: 1px solid $cc-resmed-white;
        }
      }
    }
  }

  .utility {
    display: none;
    background-color: #0D0A15 !important;

    ul {
      padding: 2rem;

      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;

      li {
        flex-grow: 1;
        text-align: center;

        a {
          @extend %body-x-small-bold;
          color: $cc-resmed-white;
          display: inline-block;

          @media (min-width: 576px) {
            font-size: $font-size-sm;
          }
        }

        &:not(:first-child) {
          border-left: 1px solid $cc-resmed-white;
        }
      }
    }
  }
}
.contact-us {
  a {
    color: #0D0A15;
    font-size: 1rem;
    font-family: "Plus Jakarta Sans";
    font-weight: 700;
  }
}
</style>